module.exports = __webpack_public_path__ + "img/Senzo.7fdc7933.png";